const INIT_STATE = {
  loading: false, //for loading
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "START_LOADING":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
